import { getNumberOfFiltersApplied, mergeState } from "contexts/workOrderSearchContextHelpers";
import pickBy from "lodash/pickBy";
import React, { Component } from "react";
import LocalStorage, { WorkOrderSearchSerializer } from "utils/LocalStorage";

const WorkOrderSearchContext = React.createContext({});

const DEFAULT_SEARCH_STATE = {
  filters: {
    customers: [],
    customWorkOrderFields: [],
    dueBetween: {
      endsAt: null,
      startsAt: null,
    },
    externalId: "",
    filterByScheduleView: false,
    itemCode: "",
    itemDescription: "",
    materialAvailabilityBetween: {
      endsAt: null,
      startsAt: null,
    },
    plannedStartBetween: {
      endsAt: null,
      startsAt: null,
    },
    scheduledBetween: {
      endsAt: null,
      startsAt: null,
    },
    showMissingData: false,
    showScheduledCompletedOrCancelled: false,
    statuses: [],
    workOrderCode: "",
  },
};

export class WorkOrderSearchProvider extends Component {
  constructor(props) {
    super(props);
    const { sessionIdentifier } = props;
    this.localStorage = new LocalStorage(WorkOrderSearchSerializer);
    this.dataStoreKey = `${sessionIdentifier}-searchState`;
    const searchParams = sanitizeSearchParams(this.localStorage.read(this.dataStoreKey));
    this.state = mergeState(DEFAULT_SEARCH_STATE, searchParams);
    this.currentState = this.state;
  }

  // Fetches current application state synchronously.
  // This is useful if you need to access current application state before setState async updates
  getCurrentState = () => this.currentState;

  updateState = (newState) => {
    const oldState = this.currentState;
    this.currentState = mergeState(oldState, newState);
    this.localStorage.write(this.dataStoreKey, this.currentState);
    this.setState(this.currentState);

    return this.currentState;
  };

  resetState = () => this.updateState(DEFAULT_SEARCH_STATE);

  contextValue = () => ({
    getState: this.getCurrentState,
    numberOfFiltersApplied: getNumberOfFiltersApplied(this.state.filters),
    resetState: this.resetState,
    setState: this.updateState,
    state: this.state,
  });

  render() {
    return (
      <WorkOrderSearchContext.Provider value={this.contextValue()}>
        {this.props.children}
      </WorkOrderSearchContext.Provider>
    );
  }
}

function sanitizeSearchParams(searchParams) {
  const isValid = (_filterValue, filterName) => filterName in DEFAULT_SEARCH_STATE.filters;
  const sanitizedFilters = pickBy(searchParams.filters, isValid);

  return { ...searchParams, filters: sanitizedFilters };
}

export default WorkOrderSearchContext;
